module.exports = __webpack_public_path__ + "img/sanyuan.e82a35ba.png";